import { render, staticRenderFns } from "./PropertyMaintenanceSystemsPanel.vue?vue&type=template&id=11568983"
import script from "./PropertyMaintenanceSystemsPanel.vue?vue&type=script&lang=ts"
export * from "./PropertyMaintenanceSystemsPanel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports